import { isMobileOrTablet, isMobileOnly } from 'os';
import { initComponents } from 'view360';
import * as handlebars from 'handlebars';
import { safeGTMuaEventsPusher } from '../utils/gtm-utilities.es6';
import { trackGA4Click360View, trackGA4Display360View, trackGA4Loading360View } from '../utils/ga4-utilities.es6';

const frameList = [];
const imageList = [];
const keyList = ['0%', '8%', '17%', '25%', '33%', '42%', '50%', '58%', '67%', '75%', '83%', '92%', '100%'];
let styleSheet = null;
const animationName = 'video360animation';
const animationTimingFunction = 'step-end';

const simulateClick = elem => {
    // Create our event (with options)
    const trigger = isMobileOrTablet() ? 'tap' : 'click';
    const evt = new MouseEvent(trigger, {
        bubbles: true,
        cancelable: true,
        view: window
    });
    // If cancelled, don't dispatch our event
    const cancelled = !elem.dispatchEvent(evt);
    return cancelled;
};

const checkImage = path => {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve({ path, status: 'ok' });
        img.onerror = () => resolve({ path, status: 'error' });

        img.src = path;
    });
};

const rebuildAnimationBox = () => {
    const videoBox = document.getElementById('videoProd360');
    const videoBoxContainer = document.getElementById('videoProd360-wrapper');

    videoBox.remove();
    const newVideoBox = document.createElement('div');
    newVideoBox.setAttribute('id', 'videoProd360');
    videoBoxContainer.appendChild(newVideoBox);
};

function getStyleCodeFromUrl() {
    return window.location.pathname.split('-p-')[1].substring(0, 15);
}

function sendStartLoading360ViewAnalyticsEvents() {
    const styleCode = getStyleCodeFromUrl();
    safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'startLoading360View', styleCode);
    trackGA4Loading360View(styleCode);
}

function sendClick360ViewAnalyticsEvents() {
    const styleCode = getStyleCodeFromUrl();
    safeGTMuaEventsPusher('interactionEvent', 'product page', 'action360View', styleCode);
    trackGA4Click360View(styleCode);
}

function sendDisplay360ViewAnalyticsEvents() {
    const styleCode = getStyleCodeFromUrl();
    safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'display360View', styleCode);
    trackGA4Display360View(styleCode);
}

const dynamicAnimation = (name, styles) => {
    if (!styleSheet) {
        styleSheet = document.createElement('style');
        styleSheet.setAttribute('id', 'prod360style');
        document.head.appendChild(styleSheet);
    }
    const imgUrlBase = isMobileOnly() ? window.prod360data.prod360url : window.prod360data.prod360urlBig;
    const animation = `${window.prod360data.prod360time} ${animationTimingFunction} ${window.prod360data.prod360iteration} ${animationName}`;
    const keyframes = `@keyframes ${name} {${styles}}`;
    const classCss = `#videoProd360 {animation: ${animation}; -webkit-animation: ${animation}; background-image: url('${imgUrlBase}');} ${keyframes}`;

    Promise.all(imageList.map(checkImage)).then(() => {
        styleSheet.innerHTML = '';
        styleSheet.appendChild(document.createTextNode(classCss));
        rebuildAnimationBox();

        sendDisplay360ViewAnalyticsEvents();
    });
};

export const createImagePath = (path, number) => {
    const splitUrl = path.split('/');
    let replacedImageName = '';
    let newPath = '';
    if (splitUrl && splitUrl.length > 0) {
        const lastPart = splitUrl[splitUrl.length - 1];
        const imageNameSplit = lastPart.split('_');
        imageNameSplit[4] = number > 9 ? `0${number}` : `00${number}`;
        replacedImageName = imageNameSplit.join('_');
        newPath = path.replace(lastPart, replacedImageName);
    }
    return newPath;
};

export const keyframesList = (path, number) => {
    for (let i = 0; i < number; i++) {
        imageList[i] = createImagePath(path, i + 1);
        if (i === number - 1) {
            frameList[i] = `${keyList[i]} { background-image: url('${createImagePath(path, i + 1)}') }`;
            frameList[number] = `${keyList[number]} { background-image: url('${createImagePath(path, 1)}') }`;
        } else {
            frameList[i] = `${keyList[i]} { background-image: url('${createImagePath(path, i + 1)}') }`;
        }
    }
    return frameList;
};

const setupStartStyle = frameKeys => {
    const stylesKeyframes = frameKeys.join(' ');
    dynamicAnimation(animationName, stylesKeyframes);
};

export const closeOverlay = () => {
    const overlay360 = document.getElementById('js-overlay-360');
    overlay360.innerHTML = '';
};

const goToZoom = () => {
    const firstZoomImageMobile = document.querySelector('.first-zoom-image-mobile');
    const firstZoomImageDesktop = document.querySelector('.first-zoom-image-desktop');

    if (window.innerWidth < 1024) {
        simulateClick(firstZoomImageMobile);
    } else {
        simulateClick(firstZoomImageDesktop);
    }
    setTimeout(() => {
        closeOverlay();
    }, 300);
};

const bindOvelayContent = () => {
    const buttonClose = document.getElementById('js-overlay360-close');
    const nextButton = document.getElementById('js-overlay360-next');

    buttonClose.addEventListener('click', () => {
        closeOverlay();
    });

    nextButton.addEventListener('click', () => {
        goToZoom();
    });
};

export const openOverlay = () => {
    sendClick360ViewAnalyticsEvents();
    const data = {};
    const container = document.querySelector('#js-overlay-360');
    const template = document.querySelector('#js-overlay-360-template');
    const sourceList = template.innerHTML;
    const templateList = handlebars.compile(sourceList);
    data.slideNumber = window.prod360data.slidesCount - 1;
    data.style = window.innerHeight > window.innerWidth ? 'width: 100vw; height: auto; margin: 0 auto;' : 'width: auto; height: 100vh; margin: 0 auto;';

    container.innerHTML = templateList(data);
    initComponents();
    bindOvelayContent();
};

export const bindGoTo360 = () => {
    const zoomOverlayContainer = document.getElementsByClassName('zoom-carousel-container--carousel');
    const zoomContainer = document.getElementsByClassName('zoom-carousel-container');
    const currentCarousel = zoomOverlayContainer.length - 1;

    const buttonBack = zoomOverlayContainer[currentCarousel].getElementsByClassName('slick-disabled');
    const zoomCloseOverlay = zoomContainer[currentCarousel].getElementsByClassName('close');

    if (buttonBack.length > 0) {
        buttonBack[0].addEventListener('click', () => {
            simulateClick(zoomCloseOverlay[0]);
            openOverlay();
        });
    }
};

const bindOverlayOpen = () => {
    const video360wrapper = document.getElementById('videoProd360-wrapper');

    video360wrapper.addEventListener('click', () => {
        openOverlay();
    });
};

export const handleAnimation = () => {
    const video360slide = document.getElementsByClassName('videoProd360-slide slick-current');
    const isShowing = video360slide && video360slide.length > 0;
    if (isShowing) {
        rebuildAnimationBox();
    }
};

const _init = () => {
    sendStartLoading360ViewAnalyticsEvents();
    const imgUrlBase = isMobileOnly() ? window.prod360data.prod360url : window.prod360data.prod360urlBig;
    const frameKeys = keyframesList(imgUrlBase, window.prod360data.prod360frames);
    setupStartStyle(frameKeys);

    bindOverlayOpen();
};

export const load = _init;
